// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__CD7P3","productName":"Table_productName__2nAp2"};